import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";
import Section12 from "./Section12";




export default function SocialMediaMarketing() {
  return (
    <div className="Social-Media-Marketing pt-[160px] sm:pt-0">
      <Helmet>
        <title>Conversion Rate Optimization in UAE | CRO Services Dubai</title>
        <meta
          name="description"
          content="Mean3 provides data-driven Conversion Rate Optimization (CRO) to maximize leads and sales in Dubai. Turn your UAE website traffic into paying customers."
        />
      </Helmet>
      <Section1 />
      <Section5 />
      <Section6 />
      <Section3 />
      <Section2 />
      <Section8 />
      <Section7 />
      <Section9 />
      <Section10 />
      <Section11 />
      <Section12 />
      <Section4 />
    </div>
  );
}
